import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "app-multi-select-dropdown",
  templateUrl: "./multi-select-dropdown.component.html",
  styleUrls: ["./multi-select-dropdown.component.css"],
})
export class MultiSelectDropdownComponent {
  @Input() list: any[];

  @Output() shareCheckedList = new EventEmitter();
  @Output() shareIndividualCheckedList = new EventEmitter();
  @Output() shareCheckedListFullObj = new EventEmitter();

  checkedList: any[];
  checkedListObjArr: any[];
  currentSelected: {};
  isSelectAll: Boolean = true;
  showDropDown: boolean = false;

  constructor() {
    this.checkedList = [];
    this.checkedListObjArr = [];
  }

  ngOnChanges() {
    const selectedData: any =
      this.list && this.list.filter(({ checked }) => checked === true);
    this.checkedListObjArr = selectedData || [];
    this.checkedList =
      (selectedData && selectedData.map(({ name }) => name)) || [];

    if (
      (this.list && this.list.length) ===
      (this.checkedList && this.checkedList.length)
    ) {
      this.isSelectAll = true;
    } else {
      this.isSelectAll = false;
    }
  }

  ngOnInit() {
    const selectedData: any =
      this.list && this.list.filter(({ checked }) => checked === true);
    this.checkedListObjArr = selectedData || [];
    this.checkedList =
      (selectedData && selectedData.map(({ name }) => name)) || [];
  }

  getSelectedValue(status: Boolean, value: String, fullObj) {
    if (status) {
      this.checkedList.push(value);
      this.checkedListObjArr.push(fullObj);
    } else {
      var index = this.checkedList.indexOf(value);
      this.checkedList.splice(index, 1);

      const finalFilterArr = this.checkedListObjArr.filter(
        ({ name }) => name !== value
      );
      this.checkedListObjArr = finalFilterArr;
    }

    this.currentSelected = { checked: status, name: value };

    //share checked list
    this.shareCheckedlist();

    //share checked list full obj
    this.shareCheckedListFullObjFun();

    //share individual selected item
    this.shareIndividualStatus();

    if (
      (this.list && this.list.length) ===
      (this.checkedList && this.checkedList.length)
    ) {
      this.isSelectAll = true;
    } else {
      this.isSelectAll = false;
    }
  }

  prepareResponse(dataList, value) {
    const finalRes: any = [];
    dataList.forEach((item: any) => {
      item = { ...item, checked: value };
      finalRes.push(item);
    });
    return finalRes;
  }

  selectedAllOption(status: Boolean, value: String, list) {
    this.isSelectAll = status;
    const checkedListData = (list && list.map(({ name }) => name)) || [];
    if (status) {
      this.checkedList = checkedListData;
      this.checkedListObjArr = list;
      this.list = this.prepareResponse(list, status);
    } else {
      this.checkedList = [];
      this.checkedListObjArr = [];
      this.list = this.prepareResponse(list, status);
    }

    this.currentSelected = { checked: status, name: value };

    //share checked list
    this.shareCheckedlist();

    //share checked list full obj
    this.shareCheckedListFullObjFun();

    //share individual selected item
    this.shareIndividualStatus();
  }

  shareCheckedlist() {
    this.shareCheckedList.emit(this.checkedList);
  }

  shareIndividualStatus() {
    this.shareIndividualCheckedList.emit(this.currentSelected);
  }

  shareCheckedListFullObjFun() {
    this.shareCheckedListFullObj.emit(this.checkedListObjArr);
  }

  handleClick(event: MouseEvent) {
    // event.stopPropagation(); // Prevent the event from bubbling up to parent elements
  }

  onMouseLeave(event: MouseEvent): void {
    // if (
    //   (event.relatedTarget as HTMLInputElement).className !==
    //   "cdk-overlay-backdrop cdk-overlay-transparent-backdrop-cs"
    // ) {
    this.showDropDown = !this.showDropDown;
    // }
  }
}
